/** Country list for lead forms: ISO 3166-1 alpha-2 codes, labels via Intl.DisplayNames. */

export const PRIORITY_COUNTRIES = ["ES", "IT", "FR", "DE", "PT", "NL", "BE", "GB"];

const ALL = (
  "AD AE AF AG AL AM AO AR AT AU AZ BA BB BD BE BF BG BH BI BJ BN BO BR BS BT BW BY BZ CA CD CF CG CH CI CL CM CN CO CR CU CV CY CZ " +
  "DE DJ DK DM DO DZ EC EE EG ER ES ET FI FJ FM FR GA GB GD GE GH GM GN GQ GR GT GW GY HK HN HR HT HU ID IE IL IN IQ IR IS IT JM JO JP " +
  "KE KG KH KI KM KN KP KR KW KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MG MH MK ML MM MN MO MR MT MU MV MW MX MY MZ NA NE NG NI NL " +
  "NO NP NR NZ OM PA PE PG PH PK PL PR PS PT PW PY QA RO RS RU RW SA SB SC SD SE SG SI SK SL SM SN SO SR SS ST SV SY SZ TD TG TH TJ TL TM " +
  "TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VN VU WS XK YE ZA ZM ZW"
).split(" ");

const displayName = (code: string, lang: string) => {
  try {
    return new Intl.DisplayNames([lang], { type: "region" }).of(code) ?? code;
  } catch {
    return code;
  }
};

export type CountryOption = { code: string; label: string };

/** Priority countries first, then the rest alphabetically in the page language. */
export const countryOptions = (lang: string): { priority: CountryOption[]; rest: CountryOption[] } => {
  const l = (lang || "es").substring(0, 2);
  const priority = PRIORITY_COUNTRIES.map((code) => ({ code, label: displayName(code, l) }));
  const rest = ALL.filter((c) => !PRIORITY_COUNTRIES.includes(c))
    .map((code) => ({ code, label: displayName(code, l) }))
    .sort((a, b) => a.label.localeCompare(b.label, l));
  return { priority, rest };
};

/** Spanish country name stored in the legacy `pais` column. */
export const countryNameEs = (code: string) => (code ? displayName(code, "es") : "");

export const isCountryCode = (code: string) => ALL.includes(code);
